import React from "react";
import { Link } from "react-router-dom";

import {Row, Col, Card, Container} from 'react-bootstrap';
import WychowaniePrzedszkolneBg from '../assets/img/wychowanie-przedszkolne.jpg';
import NiemieckiBg from '../assets/img/2.png';
import FrancuskiBg from '../assets/img/1.png';
import RosyjskiBg from '../assets/img/4.png';
import HiszpanskiBg from '../assets/img/3.png';

const MainCategoriesComponent = () => {
 
  return(
    <React.Fragment>
      
    <Container>
      
      <Row className="mt-4">
        <Col sm={12} md={12} lg={12} >
          <Card className="headerText">
            <Card.Body>
              <strong>Baza wiedzy</strong> to stale rozwijany przez nas zbiór wartościowych materiałów dydaktycznych. To nie tylko pełna dokumentacja nauczyciela, ale również setki gotowych do wykorzystania na zajęciach scenariuszy, kart pracy, sprawdzianów, kartkówek, prezentacji, grafik, dyplomów i wiele innych ciekawych pomocy edukacyjnych.
            </Card.Body>
          </Card>
        </Col>
          
      </Row>

      <Row className="mt-4">

        <Col sm={12} md={6} lg={3} >
          <Card>
            <Card.Img variant="top" src={WychowaniePrzedszkolneBg} />
            <Card.Body>
              <Card.Title><strong>Wychowanie przedszkolne</strong></Card.Title>
             
              <a href="/wychowanie-przedszkolne" className="w-100 mt-2 btn btn-primary">Przejdź do wyboru kategorii</a>
            </Card.Body>
          </Card>
        </Col>

        
        <Col sm={12} md={6} lg={3}>
          <Card>
            <Card.Img variant="top" src={NiemieckiBg} />
            <Card.Body>
              <Card.Title><strong>Język niemiecki</strong></Card.Title>
              
              <a href="/jezyk-niemiecki"className="w-100 mt-2 btn btn-primary">Przejdź do wyboru kategorii</a>
            </Card.Body>
          </Card>
        </Col>

        <Col sm={12} md={6} lg={3}>
          <Card>
            <Card.Img variant="top" src={HiszpanskiBg} />
            <Card.Body>
              <Card.Title><strong>Język hiszpański</strong></Card.Title>
             
              <a href="/jezyk-hiszpanski"className="w-100 mt-2 btn btn-primary">Przejdź do wyboru kategorii</a>
            </Card.Body>
          </Card>
        </Col>

        <Col sm={12} md={6} lg={3}>
          <Card>
            <Card.Img variant="top" src={RosyjskiBg} />
            <Card.Body>
              <Card.Title><strong>Język rosyjski</strong></Card.Title>
            
              <a href="/jezyk-rosyjski"className="w-100 mt-2 btn btn-primary">Przejdź do wyboru kategorii</a>
            </Card.Body>
          </Card>
        </Col>

       

      </Row>

      <Row className="mt-4 mb-4">

      <Col sm={12} md={6} lg={3}>
          <Card>
            <Card.Img variant="top" src={FrancuskiBg} />
            <Card.Body>
              <Card.Title><strong>Język francuski</strong></Card.Title>
             
              <a href="/jezyk-francuski"className="w-100 mt-2 btn btn-primary">Przejdź do wyboru kategorii</a>
            </Card.Body>
          </Card>
        </Col>
        
      </Row>

    </Container>

    </React.Fragment>
  )

}
export default MainCategoriesComponent;